exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-discovery-wall-block,.ebx-discovery-wall-block__grid{width:100%}", ""]);
